//      
                                                                          

export default (
  draggable                    ,
  destination                    ,
)          => draggable.descriptor.droppableId === destination.descriptor.id;



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/droppable/is-home-of.js